module.exports = __webpack_public_path__ + "img/honour-pic-1.0221f4b2.png";